// extracted by mini-css-extract-plugin
module.exports = {"root":"CoverCard-module--root--2nF5R","caption":"CoverCard-module--caption--adgM7"};